var React = require('react');

function CheckCircleIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-860 -439)"},React.createElement("path",{"className":"primary-fill","d":"M11,5a6,6,0,1,0,6,6A6,6,0,0,0,11,5Zm0,2.212a.935.935,0,1,1-.935.935A.936.936,0,0,1,11,7.212Zm0,2.494a.9.9,0,0,1,.617.246.819.819,0,0,1,.249.593v3.4a.819.819,0,0,1-.253.6.893.893,0,0,1-1.232-.009.819.819,0,0,1-.245-.589v-3.4a.82.82,0,0,1,.249-.593A.894.894,0,0,1,11,9.706Z","transform":"translate(855 434)"})));
}

CheckCircleIcon.defaultProps = {"viewBox":"0 0 12 12","className":"icon info-circle"};

module.exports = CheckCircleIcon;

CheckCircleIcon.default = CheckCircleIcon;
